import { memo } from "react";

import { TableColumnMeta } from "ds/components/Table/types";
import TableHeadInteractiveColumn from "ds/components/Table/Head/InteractiveColumn";

import usePersonalSettingsSpacesTableStore from "../usePersonalSettingsSpacesTableStore";
import { PERSONAL_SETTINGS_SPACES_TABLE_STORAGE_KEY } from "../constants";

type PersonalSettingsSpacesTableHeadColumnProps = {
  column: TableColumnMeta;
  isLast?: boolean;
};

const PersonalSettingsSpacesTableHeadColumn = memo(
  ({ column, isLast }: PersonalSettingsSpacesTableHeadColumnProps) => {
    return (
      <TableHeadInteractiveColumn
        column={column}
        store={usePersonalSettingsSpacesTableStore}
        filtersStorageKey={PERSONAL_SETTINGS_SPACES_TABLE_STORAGE_KEY}
        isLast={isLast}
      />
    );
  }
);

PersonalSettingsSpacesTableHeadColumn.displayName = "PersonalSettingsSpacesTableHeadColumn";

export default PersonalSettingsSpacesTableHeadColumn;
